import { Middleware } from '@reduxjs/toolkit';

import { dashboardSlice } from './dashboard.slice';

export const dashboardMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const dashboardState = api.getState()?.[dashboardSlice.name];

  if (dashboardState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dashboardMiddlewares[action?.type]?.(dashboardState, action);
  }

  return result;
};

const dashboardMiddlewares = {};
